/**
 * VehicleDamage actions
 */
export enum VehicleDamageActionEnum {
	/**
	 * Set road tax status to approved
	 */
	APPROVE = 'approve',

	/**
	 * Set road tax status to rejected
	 */
	REJECT = 'reject',

	/**
	 * Set road tax status to repaired
	 */
	REPAIR = 'repair',

	/**
	 * Set road tax status to ignored
	 */
	IGNORE = 'ignore',

	/**
	 * Set road tax status to pending
	 */
	PENDING = 'make_pending',

	/**
	 * Estimate damage cost
	 */
	ESTIMATE = 'estimate',

	/**
	 * Create maintenance record linked to damage
	 */
	CREATE_MAINTENANCE = 'create_maintenance',
}
